module.exports = __webpack_public_path__ + "static/media/pdf-icon.76036a91.png";